import React, {useState, useEffect} from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd'
import {EditOutlined, SearchOutlined, DeleteOutlined} from '@ant-design/icons'
import apiRequest from '../../hooks/ApiRequest'
import Layouts from '../../components/Layouts'
import AddEditInsurer from './AddEditInsurer'
import hasPermissions from '../../hooks/Permissions'
import {toast} from 'react-toastify'
import CommonSearch from '../../hooks/Search'

const InsurerList = () => {
  const [nationalID, setNationalID] = useState('')
  const [baseData, setBaseData] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectInsurerID, setSelectInsurerID] = useState(null)
  const [insurerPermission, setInsurerPermission] = useState()

  useEffect(() => {
    fetchPermissions()
    fetchRoles()
  }, [])

  const fetchPermissions = async () => {
    const permissions = await hasPermissions('Insurer')
    setInsurerPermission(permissions)
  }

  const fetchRoles = async () => {
    setLoading(true)
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_AUTH + '/api/Auth/getAllUsersByRole/308',
      )
      setBaseData(response.data)
    } catch (error) {
      console.error('Error fetching insurers', error)
      // message.error('Failed to fetch insurers.')
    } finally {
      setLoading(false)
    }
  }

const handleSearch = (value) => {
  const lowerValue = value.toLowerCase().trim();
  const filterTable = baseData.filter(o => {
    const fullName = `${o.firstName || ''} ${o.lastName || ''}`.toLowerCase();
    return (
      fullName.includes(lowerValue) ||
      String(o.email || '').toLowerCase().includes(lowerValue) ||
      String(o.mobileNumber || '').toLowerCase().includes(lowerValue)
    );
  });
  setBaseData(filterTable);
};

  const ClearSerach = () => {
    setNationalID('')
    setBaseData(baseData)
    fetchRoles()
  }

  const handleCreateInsurer = () => {
    setSelectInsurerID(null)
    setModalVisible(true)
  }

  const handleEditInsurer = roleId => {
    setSelectInsurerID(roleId)
    setModalVisible(true)
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchRoles()
  }

  const handleDelete = async recordId => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/user/delete-with-policy-check/Insureradmin/${recordId}`,
        'POST',
      )
      if (response.data.success) {
        toast.success('Insurer deleted successfully')
        await fetchRoles()
      } else {
        toast.error(response.data.message || 'Failed to delete Insurer')
      }
    } catch (error) {
      console.error('Error deleting Insurer:', error)
      toast.error('Error deleting Insurer')
    }
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => `${record.firstName} ${record.lastName}`,
    },
    {title: 'Email', dataIndex: 'email', key: 'email'},
    {title: 'Phone', dataIndex: 'mobileNumber', key: 'mobileNumber'},
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          {insurerPermission['12'] ? (
            <Tooltip title="Edit">
              <Button
                type="primary"
                className="edit_btn"
                onClick={() => handleEditInsurer(record.id)}>
                <EditOutlined />
              </Button>
            </Tooltip>
          ) : null}
          <Popconfirm
            title="Are you sure to delete this claim limit?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No">
            <Tooltip title="Delete">
              <Button type="danger" style={{marginLeft: 8}}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]

  return (
    <div title="Insurers" className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]} align="middle">
         <Col xs={24} sm={24} md={24} lg={6} xl={12}>
            <div className="section-top-heading">
              <h3
                style={{color: '#0C1362', fontWeight: '600', fontSize: '20px'}}>
                Manage Insurer Products
              </h3>
            </div>
          </Col>
         <Col xs={24} sm={24} md={12} lg={8} xl={5}>
            <div className="item-search">
              <CommonSearch
                value={nationalID}
                onChange={e => setNationalID(e.target.value)}
                onSearch={handleSearch}
                onClear={ClearSerach}
              />
            </div>
          </Col>
         <Col xs={10} sm={10} md={6} lg={3} xl={3}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={()=>handleSearch(nationalID)}
                style={{marginLeft: 10}}>
                Search
              </Button>
            </div>
          </Col>
          {/* <Col xs={14} sm={14} md={6} lg={5} xl={4}>
            {insurerPermission && insurerPermission['11'] && (
              <div className="create-quotation">
                <Button type="primary" onClick={handleCreateInsurer}>
                  Create Insurer
                </Button>
              </div>
            )}
          </Col> */}
        </Row>
      </div>

      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{display: 'block', marginTop: 20}}
        />
      ) : (
        <Table columns={columns} dataSource={baseData} rowKey="id" />
      )}

      {/* RoleForm Modal */}
      <Modal
        title={selectInsurerID ? 'Edit Insurer' : 'Add Insurer'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}>
        <AddEditInsurer
          insurerID={selectInsurerID}
          onSuccess={handleModalClose}
        />
      </Modal>
    </div>
  )
}

export default InsurerList
